import getDevSidebar from '../../customApp/sidebar';

let optionss = [
  ...getDevSidebar
];
export default optionss;
